import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import documentListItemRemoved, {
	type DocumentListItemRemovedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentListItemRemoved';
import documentListItemRemovalFailed, {
	type DocumentListItemRemovalFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentListItemRemovalFailed';
import type RemoveDocumentListItem from '@Application/Beneficiaries/Documents/Commands/RemoveDocumentListItem';
import { del } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentListItemRemovedAction | DocumentListItemRemovalFailedAction;

export default (command: RemoveDocumentListItem) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<DocumentDetailPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}/lists/${encodeURIComponent(command.listKey)}/items/${command.index}`,
			);

			const action = documentListItemRemoved(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentListItemRemovalFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
